import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { CategoryHotels } from '../core/CategoryHotels';
import { FormatterUtils, getHotelSlug, makeid } from '../core/Const';
import { BookingData, HotelBedBookingData, HotelBedCatalogData, SecurityData } from '../shared/index';
import { getAjaxhelper, isNull, momentWrapper, momentDuration } from '../utils/index';
export interface ResponseBooking {
    id?: number;
    hotelDetail?: HotelBedCatalogData.Hotel;
    hotelPhone?: HotelBedCatalogData.HotelsPhones[];
    bookingData?: HotelBedBookingData.BookingRequestResponse;
    paymentData?: any;
    customerData?: BookingData.Customer;
    statusCode?: string;
    errorMessage?: {
        booking?: string,
        payment?: string
    };
    curencyCode?: string;
    curencyValue?: number;
}

export interface BookingVoucherProps extends BaseComponentProps {
    bookingId: string;
    userLogin: SecurityData.ApplicationUser;
}

export interface BookingVoucherState extends BaseComponentState {
    error: boolean;
    errorMessage: any;
    errorCode: string | any;
    bookingData?: HotelBedBookingData.BookingRequestResponse;
    paymentData?: any;
    customerData?: BookingData.Customer;
    requesting: boolean;
    hotelDetail?: HotelBedCatalogData.Hotel;
    hotelPhones?: HotelBedCatalogData.HotelsPhones[];
    curencyCode?: string;
    curencyValue?: number;
}

export class BookingVoucher extends BaseComponent<BookingVoucherProps, BookingVoucherState> {
    static CODE_RECHECK: string[] = ['HB_BOOKING_REQUEST', 'STRIPE_REQUEST'];
    constructor(props: BookingVoucherProps) {
        super(props);
        this.state = {
            error: false,
            errorMessage: null,
            errorCode: null,
            requesting: true,
        };
    }

    componentDidMount() {
        this.chkBooking();
    }
    componentDidUpdate(prevProps: BookingVoucherProps, prevState: BookingVoucherState) {
        if (prevProps.bookingId !== this.props.bookingId || prevProps.userLogin !== this.props.userLogin) {
            // this.chkBooking();
        }
    }

    chkBooking = () => {
        getAjaxhelper().post("/dynamics/hb-api/booking-confirm", {
            bookingId: this.props.bookingId
        }).then(
            (data: ResponseBooking) => {
                if (BookingVoucher.CODE_RECHECK.indexOf(data.statusCode!) >= 0) {
                    setTimeout(this.chkBooking, 2000);
                    return;
                }
                console.log("HotelBookCheckoutData", data);
                if (data.statusCode === 'SUCCESS' || data.statusCode === 'CANCELED') {
                    this.setStateHelper(st => {
                        st.error = false;
                        st.bookingData = data.bookingData;
                        st.customerData = data.customerData;
                        st.paymentData = data.paymentData;
                        st.requesting = false;
                        st.hotelDetail = data.hotelDetail;
                        st.hotelPhones = data.hotelPhone;
                        st.curencyCode = data.curencyCode;
                        st.curencyValue = data.curencyValue;

                    });
                } else {
                    let err1 = <span />;
                    let err2 = <span />;
                    if (!isNull(data.errorMessage!.booking)) {
                        err1 = <span> <strong>Booking Error Message:</strong> {data.errorMessage!.booking!}</span>;
                    }
                    if (!isNull(data.errorMessage!.payment)) {
                        err2 = <span> <strong>Payment Error Message:</strong> {data.errorMessage!.payment!} </span>;
                    }
                    this.setStateHelper(st => {
                        st.error = true;
                        st.requesting = false;
                        st.errorMessage = <p className="margin-bottom-10"> {err1} <br /> {err2} </p>;
                    });
                }

            }).catch(exc => {
                console.log("HotelBookCheckoutData error", exc);
                this.setStateHelper(st => {
                    st.errorMessage = <p className="margin-bottom-10">{exc.message}</p>;
                    st.error = true;
                    st.errorCode = exc.errorCode;
                    st.requesting = false;
                });

            });
    }
    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let page = <span />;
        let pt: string | any = '';
        let vat: string  | any = '';
        let refNo: string  = '';
        if (!this.state.requesting) {
            if (this.state.error) {
                page = (
                    <div  >
                    <div className="alert alert-block alert-danger fade in">
                        <h4 className="alert-heading margin-bottom-10"><i className="ti-close" />Your Booking Is Almost Complete. We Will Contact You Soon To Confirm</h4>
                        <p className="margin-bottom-10">
                            Please contact our sales team to complete your booking direct.
                        </p>
                        <p>
                            Email – <a href="mailto: info@balihotelsandmore.com?subject=Booking Error">info@balihotelsandmore.com</a> <br />
                            WhatsApp International Free Call : <a href="https://api.whatsapp.com/send?phone=6287860006919&text=Booking Error! Please Help" target="_blank">0878 6000 6919</a> <br />
                            Australia – <a href="cal:1300 582 556">1300 582 556</a><br />
                        </p>
                        <p>We cant wait to see you in Bali!</p>
                        <p>Don’t forget with every hotel booking you get more with Bali Hotels And More.</p>

                        <p>Book your room for just $1 and pay before you arrive. Bali Hotels And More offer the best luxury hotels at fantastic rates. All include</p>
                        <ul>
                            <li>FREE airport transfers with bookings over 5 days</li>
                            <li>FREE tours for kids valued at $450!  - <a href="https://www.balihotelsandmore.com/bali-tours">https://www.balihotelsandmore.com/bali-tours</a></li>
                            <li>Get 10% off travel insurance!</li>
                            <li>Save hundreds on Bali restaurants, beach clubs and spas. You’re now a VIP - <a href="http://www.baliholidaysandmorevip.com" target="_blank">http://www.baliholidaysandmorevip.com</a></li>
                            <li>We live here so we know what will make the most amazing Bali holiday memories!</li>
                        </ul>
                        <p>https://www.balihotelsandmore.com</p>
                    </div>
                    <div className="alert alert-block alert-danger fade in">
                        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                        <h4 className="alert-heading margin-bottom-10"><i className="ti-close" /> Error!</h4>

                        {this.state.errorMessage}

                    </div>
                </div>
                    
                );
            } else {
                // let email = 
                let mailto = `mailto: ${ this.state.customerData &&  this.state.customerData.email ?  this.state.customerData.email : ""}`;
                let hotelPhones = [];

                if (!isNull(this.state.hotelPhones)) {
                    for (let a of this.state.hotelPhones!) {
                        if (a.phoneType === 'FAXNUMBER') {
                            hotelPhones.push(
                                <span key={makeid()} > <i className="fa fa-fax" /> {a.phoneNumber} </span>
                            );
                        } else if (a.phoneType === 'PHONEBOOKING') {
                            hotelPhones.push(
                                <span key={makeid()} > <i className="fa fa-headphones" /> {a.phoneNumber} </span>
                            );
                        } else {
                            hotelPhones.push(
                                <span key={makeid()} > <i className='fa fa-phone' /> {a.phoneNumber}  </span>
                            );
                        }
                    }
                }
                let mailtoHotel = `mailto: ${this.state.hotelDetail && this.state.hotelDetail.email ? this.state.hotelDetail.email : ' '}`;
                let hotelPhone = <p>{hotelPhones}</p>;
                pt = this.state.bookingData!.hotel.supplier!.name;
                vat = this.state.bookingData!.hotel.supplier!.vatNumber;
                refNo = this.state.bookingData!.reference;
                page = (
                    <div className='invoice panel panel-white'>
                        <div className='panel-body row'>
                            <div className='col-md-12 '>
                                <div className='col-md-6'>
                                    <h2>E-Voucher <br /> <span style={{ fontSize: '0.5em' }}> Hotel Booking </span></h2>
                                </div>
                                <div className='col-md-6 text-right'>
                                    <img src='/assets/images/logo.png' />
                                </div>
                            </div>

                            <div className='col-md-12'>
                                <div className='col-md-4' style={{ paddingTop: 10 }}>
                                    <div className='panel-body well'>
                                        <h3>Booking Holder</h3>
                                        {this.state.bookingData!.holder.name + ' ' + this.state.bookingData!.holder.surname} <br />
                                        {this.state.customerData!.address} <br />
                                        {this.state.customerData!.postalCode} <br />
                                        {this.state.customerData!.city} <br />
                                        {this.state.customerData!.state} <br />
                                        Email : <a href={mailto}> {this.state.customerData!.email}</a>
                                    </div>
                                </div>
                                <div className='col-md-2'>
                                    <span />
                                </div>
                                <div className='col-md-6  '>
                                    <table className='table book table-striped' style={{ border: '1px solid #eee', padding: 10, marginTop: 15 }}>
                                        <tr>
                                            <td colSpan={3} style={{ verticalAlign: 'top', textAlign: 'left' }}>
                                                <h3>
                                                    <a href={getHotelSlug(this.state.bookingData!.hotel.name, this.state.bookingData!.hotel.code)}>  <h3>{this.state.bookingData!.hotel.name} 
                                                    <CategoryHotels
                                                        star={this.state.hotelDetail!.Category!.simpleCode!}
                                                    /> </h3>
                                                    </a>
                                                </h3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ verticalAlign: 'top', textAlign: 'left' }} >Booking Id</td>
                                            <td style={{ verticalAlign: 'top', textAlign: 'left' }}>:</td>
                                            <td>{this.state.bookingData!.clientReference}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ verticalAlign: 'top', textAlign: 'left' }}>Reference No</td>
                                            <td style={{ verticalAlign: 'top', textAlign: 'left' }}>:</td>
                                            <td>{this.state.bookingData!.reference}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ verticalAlign: 'top', textAlign: 'left' }}>Booking Date</td>
                                            <td style={{ verticalAlign: 'top', textAlign: 'left' }}>:</td>
                                            <td>{this.state.bookingData!.creationDate}</td>
                                        </tr>
                                        <tr>
                                            <td style={{ verticalAlign: 'top', textAlign: 'left' }}>Booking Status</td>
                                            <td style={{ verticalAlign: 'top', textAlign: 'left' }}>:</td>
                                            <td>
                                                {this.state.bookingData!.modificationPolicies.cancellation ? <span className='REFUNDABLE'>REFUNDABLE</span> : <span />} <br />
                                                {this.state.bookingData!.modificationPolicies.modification ? <span className='REFUNDABLE'>MODIFIABLE</span> : <span />}
                                            </td>
                                        </tr>
                                    </table>

                                </div>
                            </div>
                            <div className='col-md-12 '>
                                <hr />
                            </div>
                            <div className='col-md-12'>
                                <div className='col-md-4'>
                                    <img src="/assets/images/calender.png" style={{ float: 'left', marginTop: 5 }} />
                                    <div style={{ margin: '5px 0px 0px 80px' }}>
                                        Check In <br />
                                        <h3 style={{ fontWeight: 500, color: '#03aeef' }}>{momentWrapper(this.state.bookingData!.hotel.checkIn).format('MMMM Do YYYY')}</h3>
                                    </div>
                                </div>
                                <div className='col-md-4'>
                                    <img src="/assets/images/calender.png" style={{ float: 'left', marginTop: 5 }} />
                                    <div style={{ margin: '5px 0px 0px 80px' }}>
                                        Check Out  <br />
                                        <h3 style={{ fontWeight: 500, color: '#03aeef' }}>{momentWrapper(this.state.bookingData!.hotel.checkOut).format('MMMM Do YYYY')}</h3>
                                    </div>
                                </div>
                                <div className='col-md-4  '>
                                    <img src="/assets/images/info.png" style={{ float: 'left', marginTop: 5 }} />
                                    <div style={{ margin: '12px 0px 0px 80px' }}>
                                        <span style={{ background: '#03aeef', fontSize: 24, color: '#fff', padding: '4px 20px', borderRadius: 10 }} > {this.state.bookingData!.status} </span>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-12 '>
                                <hr />
                            </div>

                            <div className='col-md-12' style={{ padding: '10px 10px ' }}>
                                <div className='col-md-12' style={{ fontSize: 20, fontWeight: 300, color: '#03aeef' }}>
                                    This voucher entitles the guest to the accommodation and services as Rated below:
                                </div>
                            </div>
                            <div className='col-md-12 '>
                                {this.renderRoomDetail(this.state.bookingData!.hotel.rooms!)}
                            </div>
                            <div className='col-md-12' style={{ padding: '0px 30px ' }}>
                                <h3>{this.state.bookingData!.hotel.name} 
                                <CategoryHotels
                                    key={'stars'}
                                    star={this.state.hotelDetail!.Category!.simpleCode!}
                                />  </h3>
                                <p>
                                    {this.state.hotelDetail!.address + ', ' + this.state.bookingData!.hotel.zoneName + ', ' + this.state.bookingData!.hotel.destinationName + ', ' + this.state.hotelDetail!.postalCode}
                                </p>
                                {hotelPhone}
                                <p><i className='ti-email' /> <a href={mailtoHotel}> {this.state.hotelDetail!.email}</a></p>
                                <p>{this.state.hotelDetail!.description}</p>
                            </div>
                            <div className='col-md-12 '>
                                <hr />
                            </div>
                        </div>
                    </div>
                );
            }
        } else {
            return (
                <div className='container' style={{ paddingTop: 140 }}> 
                    <h4 style={{textAlign: 'center'}}>Please Wait</h4>
                    <div className='loader' />
                </div>
            );
        }

        return (
            <div className='container' style={{ paddingTop: 140 }}>
                {page}
                <div style={{ paddingBottom: 30 }}>
                    Payable through {pt}, acting as agent for the service operating company, details of which can be provided upon request. VAT: ({vat}) Reference: {refNo}
                </div>
            </div>
        );
    }
    renderRoomDetail: (rooms: HotelBedBookingData.BookingResponseRoomData[]) => any = (rooms: HotelBedBookingData.BookingResponseRoomData[]) => {
        let ret: any[] = [];
        rooms.forEach(room => {

            let rateComp: any[] = [];
            let childrenAgeHeader = <span />;
            let loop = 0;
            let childrenAgeData = '';
            for (let pax of room.paxes) {
                if (pax.type === 'CH') {
                    if (loop > 0) {
                        childrenAgeData += ',';
                    }
                    childrenAgeHeader = <td>Children Age/s</td>;
                    childrenAgeData += pax.age;
                    loop += 1;
                }
            }
            let pessangerObj = <span />;
            let colSpan = 5;
            let Passanger = '';
            let idxPaxName = {};

            if (!isNull(room.paxes)) {
                for (let pax of room.paxes) {
                    if ((!isNull(pax.name) && pax.name.trim().length !== 0) || (!isNull(pax.surname) && pax.surname.trim.length !== 0)) {
                        if (isNull(idxPaxName[pax.name + ' ' + pax.surname])) {
                            idxPaxName[pax.name + ' ' + pax.surname] = {};
                        }
                    }
                }
            }

            let lop = 0;
            for (let a of Object.keys(idxPaxName)) {
                if (lop > 0) {
                    Passanger += ', ';
                }
                Passanger += a;
                lop++;
            }
            if (Passanger !== '') {
                pessangerObj = (
                    <tr key={makeid()} style={{ lineHeight: '40px' }}>
                        <td style={{ paddingLeft: 10 }} colSpan={colSpan}>
                            Passanger : {Passanger}
                        </td>
                    </tr>
                );
                rateComp.push(pessangerObj);
            }

            room.rates!.forEach(rate => {
                let cancelPolice: any[] = [];
                if (!isNull(rate.cancellationPolicies)) {
                    rate.cancellationPolicies!.forEach(cancel => {
                        cancelPolice.push(
                            <span key={makeid()} > From : {momentWrapper(cancel.from).format('MMMM Do YYYY') + ' Amount: ' + ' ' + new FormatterUtils().formatMoney(cancel.amount * this.state.curencyValue!, this.state.curencyCode!, true, false)}  </span>
                        );
                        cancelPolice.push(
                            <br />
                        );
                    });
                }
                let fr = momentWrapper(this.state.bookingData!.hotel.checkIn);
                let to = momentWrapper(this.state.bookingData!.hotel.checkOut);
                let night = momentDuration(to.diff(fr)).as('day');
                let renChildrenAgeData = <span />;
                if (childrenAgeData !== '') {
                    renChildrenAgeData = <td style={{ paddingLeft: 10 }}> {childrenAgeData} </td>;
                }
                rateComp.push(
                    <tr key={makeid()} style={{ lineHeight: '40px' }}>
                        <td style={{ paddingLeft: 10 }}> {room.name} </td>
                        <td style={{ paddingLeft: 10 }}> {night} Night/s</td>
                        <td style={{ paddingLeft: 10 }}> {rate.boardName} </td>
                        {renChildrenAgeData}
                        <td style={{ paddingLeft: 10 }}>{rate.rooms} <i className='fa fa-bed' /> {rate.adults} <i className='fa fa-user' />{rate.children}<i className='fa fa-child' /></td>
                    </tr>
                );
                rateComp.push(
                    <tr key={makeid()} >
                        <td style={{ paddingLeft: 10 }} colSpan={5}>
                            <p> Cancelation Policies: <br /> {cancelPolice}</p>
                            <p>Remark: <br />{rate.rateComments}</p>

                        </td>
                    </tr>
                );
            });
            ret.push(
                <table key={makeid()} className="table  " style={{ marginTop: 0 }}>
                    <thead>
                        <tr>
                            <th>Room Type</th>
                            <th>Number of Night/s</th>
                            <th>Board</th>
                            {childrenAgeHeader}
                            <th>Detail</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rateComp}
                    </tbody>

                </table>
            );
        });
        return ret;
    }

}


// WEBPACK FOOTER //
// ./src/new-booking/BookingVoucher.tsx